import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render publicity section for FAQ Page
 */
const PublicitySection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="publicity-section-component"
    >
      <AccordionV2
        testId="publicity"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="4. Are all shortlisted businesses given publicity in The Business Times?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 pb-2 pt-6">
          <p>
            Only semi finalists and finalists will be featured in The Business
            Times.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default PublicitySection;
